import { styled } from '@mui/material/styles';
import { Container as MuiContainer } from '@mui/material';

const Container = styled(MuiContainer)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 3),
  },
}));

export default Container;
